function createLotsAccessRouteHandler(authAccess, companyStatus) {
  return authAccess && companyStatus === 'active';
}

function createLotsAccessButtonHandler(authAccess, locations, companyStatus) {
  return authAccess && locations.length > 0 && companyStatus === 'active';
}

export { createLotsAccessRouteHandler, createLotsAccessButtonHandler };
